export const namespaced = true;

export const state = {
  notifications: []
};

let nextId = 1;

export const mutations = {
  PUSH(state, notification) {
    // state.notifications.push({
      //   ...notification,
      //   id: nextId++
      // });
    const allObj = Object.assign(notification, {      
      id: nextId++
    });
    state.notifications.push(allObj);
  },
  CHANGE(state, notification) {
    const allObj = Object.assign(notification, {      
      id: nextId
    });
    state.notifications = [allObj];
    // state.notifications = [
    //   {
    //     ...notification,
    //     id: nextId
    //   }
    // ];
  },
  DELETE(state, notificationToRemove) {
    state.notifications = state.notifications.filter(
      notification => notification.id !== notificationToRemove.id
    );
  }
};

export const actions = {
  add({ commit }, notification) {
    commit("PUSH", notification);
  },
  replace({ commit }, notification) {
    commit("CHANGE", notification);
  },
  remove({ commit }, notificationToRemove) {
    commit("DELETE", notificationToRemove);
  }
};
